import styled, { css, keyframes } from 'styled-components';
import { colors, font, radius, shadow } from '../../../styles/theme/tokens';

const rise = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
`;

const starPop = keyframes`
  0% { transform: scale(0.6); opacity: 0; }
  60% { transform: scale(1.12); opacity: 1; }
  100% { transform: scale(1); }
`;

export const Wrapper = styled.div`
  padding: 20px;
  font-family: ${font.text};
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 820px;
  word-wrap: break-word;
  animation: ${rise} 0.3s ease-out;
`;

export const Button = styled.button`
  align-self: center;
  padding: 11px 24px;
  border-radius: ${radius.pill};
  font-family: ${font.text};
  font-size: 15px;
  font-weight: 700;
  color: ${colors.brandDeep};
  background: ${colors.surface};
  border: 1.5px solid ${colors.line};
  cursor: pointer;
  transition: border-color 0.15s ease;

  &:hover {
    border-color: ${colors.brand};
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const resultCard = css`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 28px 24px 24px;
  border-radius: ${radius.xl};
  text-align: center;
  font-family: ${font.text};
  animation: ${rise} 0.3s ease-out;

  h2 {
    font-size: 20px;
    font-weight: 800;
  }

  p {
    font-size: 15px;
    font-weight: 500;
    line-height: 1.5;
    max-width: 460px;
  }
`;

export const SubmissionSuccess = styled.div`
  ${resultCard};
  color: ${colors.ink};
  background: ${colors.surface};
  border: 1px solid ${colors.line};
  box-shadow: ${shadow.card};

  p {
    color: ${colors.muted};
  }
`;

export const SubmissionError = styled.div`
  ${resultCard};
  color: ${colors.danger};
  background: ${colors.dangerSoft};
`;

export const CloseIcon = styled.span`
  position: absolute;
  top: 12px;
  right: 14px;
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: ${radius.pill};
  font-size: 22px;
  line-height: 1;
  color: ${colors.muted};
  background: ${colors.bg};
  cursor: pointer;
`;

export const StarAward = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: ${font.text};
  font-size: 24px !important;
  font-weight: 800 !important;
  color: ${colors.ink} !important;
  animation: ${starPop} 0.6s ease-out;
`;
